/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { JsonPipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MessageService } from '@src/app/shared/message.service';

@Component({
    selector: 'app-show-json',
    imports: [MatButtonModule, MatDialogModule, JsonPipe],
    templateUrl: './show-json.component.html',
    styleUrl: './show-json.component.scss'
})
export class ShowJSONComponent {
    @Input() title: string;
    @Input() object: unknown;
    //@Inject(MAT_DIALOG_DATA) public data: CDSData
    data = inject(MAT_DIALOG_DATA)
    msgSvc = inject(MessageService);
    dialogRef = inject(MatDialogRef<ShowJSONComponent>);

    takeAction() {
      if (!this.data.actionName || !this.data.actionReturns) {
        this.msgSvc.showErrorMessage('No actionName or no actionReturns defined');
      } else {
        this.dialogRef.close(this.data.actionReturns);        
      }
    }
}
